import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3974a0b3 = () => interopDefault(import('../../../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _484494f6 = () => interopDefault(import('../../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _619ff302 = () => interopDefault(import('../../../pages/account/chats/index.vue' /* webpackChunkName: "pages/account/chats/index" */))
const _3f3af381 = () => interopDefault(import('../../../pages/account/drafts/index.vue' /* webpackChunkName: "pages/account/drafts/index" */))
const _41bc1599 = () => interopDefault(import('../../../pages/account/edit/index.vue' /* webpackChunkName: "pages/account/edit/index" */))
const _4b556810 = () => interopDefault(import('../../../pages/account/following/index.vue' /* webpackChunkName: "pages/account/following/index" */))
const _3de029be = () => interopDefault(import('../../../pages/account/listings/index.vue' /* webpackChunkName: "pages/account/listings/index" */))
const _7dbe878f = () => interopDefault(import('../../../pages/account/notifications/index.vue' /* webpackChunkName: "pages/account/notifications/index" */))
const _cf9af098 = () => interopDefault(import('../../../pages/account/orders/index.vue' /* webpackChunkName: "pages/account/orders/index" */))
const _5a2e47fc = () => interopDefault(import('../../../pages/account/reviews/index.vue' /* webpackChunkName: "pages/account/reviews/index" */))
const _02eb84ac = () => interopDefault(import('../../../pages/account/vacation/index.vue' /* webpackChunkName: "pages/account/vacation/index" */))
const _72922fc8 = () => interopDefault(import('../../../pages/account/wallet/index.vue' /* webpackChunkName: "pages/account/wallet/index" */))
const _3fe28acb = () => interopDefault(import('../../../pages/account/wardrobe/index.vue' /* webpackChunkName: "pages/account/wardrobe/index" */))
const _2c850096 = () => interopDefault(import('../../../pages/account/listing/_id/index.vue' /* webpackChunkName: "pages/account/listing/_id/index" */))
const _2f1d4487 = () => interopDefault(import('../../../pages/account/order/_transactionId.vue' /* webpackChunkName: "pages/account/order/_transactionId" */))
const _6269b7f6 = () => interopDefault(import('../../../pages/account/listing/_id/edit.vue' /* webpackChunkName: "pages/account/listing/_id/edit" */))
const _4bfe5f7c = () => interopDefault(import('../../../pages/content/index.vue' /* webpackChunkName: "pages/content/index" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _765e6d9f = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _162680ce = () => interopDefault(import('../../../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _000cf64e = () => interopDefault(import('../../../pages/listings.vue' /* webpackChunkName: "pages/listings" */))
const _0104a354 = () => interopDefault(import('../../../pages/listings/_slug.vue' /* webpackChunkName: "pages/listings/_slug" */))
const _65407a9c = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _7460a47e = () => interopDefault(import('../../../pages/order-confirmation/index.vue' /* webpackChunkName: "pages/order-confirmation/index" */))
const _21ff39c4 = () => interopDefault(import('../../../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */))
const _9ca1a860 = () => interopDefault(import('../../../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _1fb125d6 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _2f2cf261 = () => interopDefault(import('../../../pages/terms-and-conditions/index.vue' /* webpackChunkName: "pages/terms-and-conditions/index" */))
const _2cf9b072 = () => interopDefault(import('../../../pages/wishlist/index.vue' /* webpackChunkName: "pages/wishlist/index" */))
const _a742e5a2 = () => interopDefault(import('../../../pages/checkout/_listingId.vue' /* webpackChunkName: "pages/checkout/_listingId" */))
const _74a7cc57 = () => interopDefault(import('../../../pages/faq/_slug.vue' /* webpackChunkName: "pages/faq/_slug" */))
const _7ed64635 = () => interopDefault(import('../../../pages/listing/_id.vue' /* webpackChunkName: "pages/listing/_id" */))
const _4264f6ea = () => interopDefault(import('../../../pages/shop/_id.vue' /* webpackChunkName: "pages/shop/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _3974a0b3,
    children: [{
      path: "",
      component: _484494f6,
      name: "account"
    }, {
      path: "chats",
      component: _619ff302,
      name: "account-chats"
    }, {
      path: "drafts",
      component: _3f3af381,
      name: "account-drafts"
    }, {
      path: "edit",
      component: _41bc1599,
      name: "account-edit"
    }, {
      path: "following",
      component: _4b556810,
      name: "account-following"
    }, {
      path: "listings",
      component: _3de029be,
      name: "account-listings"
    }, {
      path: "notifications",
      component: _7dbe878f,
      name: "account-notifications"
    }, {
      path: "orders",
      component: _cf9af098,
      name: "account-orders"
    }, {
      path: "reviews",
      component: _5a2e47fc,
      name: "account-reviews"
    }, {
      path: "vacation",
      component: _02eb84ac,
      name: "account-vacation"
    }, {
      path: "wallet",
      component: _72922fc8,
      name: "account-wallet"
    }, {
      path: "wardrobe",
      component: _3fe28acb,
      name: "account-wardrobe"
    }, {
      path: "listing/:id",
      component: _2c850096,
      name: "account-listing-id"
    }, {
      path: "order/:transactionId?",
      component: _2f1d4487,
      name: "account-order-transactionId"
    }, {
      path: "listing/:id?/edit",
      component: _6269b7f6,
      name: "account-listing-id-edit"
    }]
  }, {
    path: "/content",
    component: _4bfe5f7c,
    name: "content"
  }, {
    path: "/en",
    component: _0547af50,
    name: "index___en"
  }, {
    path: "/faq",
    component: _765e6d9f,
    name: "faq"
  }, {
    path: "/forgot-password",
    component: _162680ce,
    name: "forgot-password"
  }, {
    path: "/listings",
    component: _000cf64e,
    name: "listings",
    children: [{
      path: ":slug?",
      component: _0104a354,
      name: "listings-slug"
    }]
  }, {
    path: "/login",
    component: _65407a9c,
    name: "login"
  }, {
    path: "/nl",
    component: _0547af50,
    name: "index___nl"
  }, {
    path: "/order-confirmation",
    component: _7460a47e,
    name: "order-confirmation"
  }, {
    path: "/privacy-policy",
    component: _21ff39c4,
    name: "privacy-policy"
  }, {
    path: "/register",
    component: _9ca1a860,
    name: "register"
  }, {
    path: "/search",
    component: _1fb125d6,
    name: "search"
  }, {
    path: "/terms-and-conditions",
    component: _2f2cf261,
    name: "terms-and-conditions"
  }, {
    path: "/wishlist",
    component: _2cf9b072,
    name: "wishlist"
  }, {
    path: "/en/account",
    component: _3974a0b3,
    children: [{
      path: "",
      component: _484494f6,
      name: "account___en"
    }, {
      path: "chats",
      component: _619ff302,
      name: "account-chats___en"
    }, {
      path: "drafts",
      component: _3f3af381,
      name: "account-drafts___en"
    }, {
      path: "edit",
      component: _41bc1599,
      name: "account-edit___en"
    }, {
      path: "following",
      component: _4b556810,
      name: "account-following___en"
    }, {
      path: "listings",
      component: _3de029be,
      name: "account-listings___en"
    }, {
      path: "notifications",
      component: _7dbe878f,
      name: "account-notifications___en"
    }, {
      path: "orders",
      component: _cf9af098,
      name: "account-orders___en"
    }, {
      path: "reviews",
      component: _5a2e47fc,
      name: "account-reviews___en"
    }, {
      path: "vacation",
      component: _02eb84ac,
      name: "account-vacation___en"
    }, {
      path: "wallet",
      component: _72922fc8,
      name: "account-wallet___en"
    }, {
      path: "wardrobe",
      component: _3fe28acb,
      name: "account-wardrobe___en"
    }, {
      path: "listing/:id",
      component: _2c850096,
      name: "account-listing-id___en"
    }, {
      path: "order/:transactionId?",
      component: _2f1d4487,
      name: "account-order-transactionId___en"
    }, {
      path: "listing/:id?/edit",
      component: _6269b7f6,
      name: "account-listing-id-edit___en"
    }]
  }, {
    path: "/en/content",
    component: _4bfe5f7c,
    name: "content___en"
  }, {
    path: "/en/faq",
    component: _765e6d9f,
    name: "faq___en"
  }, {
    path: "/en/forgot-password",
    component: _162680ce,
    name: "forgot-password___en"
  }, {
    path: "/en/listings",
    component: _000cf64e,
    name: "listings___en",
    children: [{
      path: ":slug?",
      component: _0104a354,
      name: "listings-slug___en"
    }]
  }, {
    path: "/en/login",
    component: _65407a9c,
    name: "login___en"
  }, {
    path: "/en/order-confirmation",
    component: _7460a47e,
    name: "order-confirmation___en"
  }, {
    path: "/en/privacy-policy",
    component: _21ff39c4,
    name: "privacy-policy___en"
  }, {
    path: "/en/register",
    component: _9ca1a860,
    name: "register___en"
  }, {
    path: "/en/search",
    component: _1fb125d6,
    name: "search___en"
  }, {
    path: "/en/terms-and-conditions",
    component: _2f2cf261,
    name: "terms-and-conditions___en"
  }, {
    path: "/en/wishlist",
    component: _2cf9b072,
    name: "wishlist___en"
  }, {
    path: "/nl/account",
    component: _3974a0b3,
    children: [{
      path: "",
      component: _484494f6,
      name: "account___nl"
    }, {
      path: "chats",
      component: _619ff302,
      name: "account-chats___nl"
    }, {
      path: "drafts",
      component: _3f3af381,
      name: "account-drafts___nl"
    }, {
      path: "edit",
      component: _41bc1599,
      name: "account-edit___nl"
    }, {
      path: "following",
      component: _4b556810,
      name: "account-following___nl"
    }, {
      path: "listings",
      component: _3de029be,
      name: "account-listings___nl"
    }, {
      path: "notifications",
      component: _7dbe878f,
      name: "account-notifications___nl"
    }, {
      path: "orders",
      component: _cf9af098,
      name: "account-orders___nl"
    }, {
      path: "reviews",
      component: _5a2e47fc,
      name: "account-reviews___nl"
    }, {
      path: "vacation",
      component: _02eb84ac,
      name: "account-vacation___nl"
    }, {
      path: "wallet",
      component: _72922fc8,
      name: "account-wallet___nl"
    }, {
      path: "wardrobe",
      component: _3fe28acb,
      name: "account-wardrobe___nl"
    }, {
      path: "listing/:id",
      component: _2c850096,
      name: "account-listing-id___nl"
    }, {
      path: "order/:transactionId?",
      component: _2f1d4487,
      name: "account-order-transactionId___nl"
    }, {
      path: "listing/:id?/edit",
      component: _6269b7f6,
      name: "account-listing-id-edit___nl"
    }]
  }, {
    path: "/nl/content",
    component: _4bfe5f7c,
    name: "content___nl"
  }, {
    path: "/nl/faq",
    component: _765e6d9f,
    name: "faq___nl"
  }, {
    path: "/nl/forgot-password",
    component: _162680ce,
    name: "forgot-password___nl"
  }, {
    path: "/nl/listings",
    component: _000cf64e,
    name: "listings___nl",
    children: [{
      path: ":slug?",
      component: _0104a354,
      name: "listings-slug___nl"
    }]
  }, {
    path: "/nl/login",
    component: _65407a9c,
    name: "login___nl"
  }, {
    path: "/nl/order-confirmation",
    component: _7460a47e,
    name: "order-confirmation___nl"
  }, {
    path: "/nl/privacy-policy",
    component: _21ff39c4,
    name: "privacy-policy___nl"
  }, {
    path: "/nl/register",
    component: _9ca1a860,
    name: "register___nl"
  }, {
    path: "/nl/search",
    component: _1fb125d6,
    name: "search___nl"
  }, {
    path: "/nl/terms-and-conditions",
    component: _2f2cf261,
    name: "terms-and-conditions___nl"
  }, {
    path: "/nl/wishlist",
    component: _2cf9b072,
    name: "wishlist___nl"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }, {
    path: "/en/checkout/:listingId?",
    component: _a742e5a2,
    name: "checkout-listingId___en"
  }, {
    path: "/en/faq/:slug",
    component: _74a7cc57,
    name: "faq-slug___en"
  }, {
    path: "/en/listing/:id?",
    component: _7ed64635,
    name: "listing-id___en"
  }, {
    path: "/en/shop/:id?",
    component: _4264f6ea,
    name: "shop-id___en"
  }, {
    path: "/nl/checkout/:listingId?",
    component: _a742e5a2,
    name: "checkout-listingId___nl"
  }, {
    path: "/nl/faq/:slug",
    component: _74a7cc57,
    name: "faq-slug___nl"
  }, {
    path: "/nl/listing/:id?",
    component: _7ed64635,
    name: "listing-id___nl"
  }, {
    path: "/nl/shop/:id?",
    component: _4264f6ea,
    name: "shop-id___nl"
  }, {
    path: "/checkout/:listingId?",
    component: _a742e5a2,
    name: "checkout-listingId"
  }, {
    path: "/faq/:slug",
    component: _74a7cc57,
    name: "faq-slug"
  }, {
    path: "/listing/:id?",
    component: _7ed64635,
    name: "listing-id"
  }, {
    path: "/shop/:id?",
    component: _4264f6ea,
    name: "shop-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
